import { useTranslation } from "react-i18next";
import { solutionsData } from "@/mocks/home";

export default function SolutionsSection() {
  const { t } = useTranslation("home");

  return (
    <section className="w-full bg-white py-12 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-start gap-8 lg:gap-12">
          <div className="w-full lg:w-1/2">
            <h2 className="text-2xl md:text-3xl font-bold text-magenta mb-6 leading-snug">
              {t("solutions.title")}
            </h2>
            <p className="text-sm md:text-base font-semibold text-text mb-4">
              {t("solutions.question")}
            </p>
            <p className="text-sm md:text-base text-text-muted leading-relaxed mb-4 text-justify">
              {t("solutions.p1")}
            </p>
            <p className="text-sm md:text-base text-text-muted leading-relaxed mb-4 text-justify">
              {t("solutions.p2")}
            </p>
            <p className="text-sm md:text-base text-text-muted leading-relaxed text-justify">
              {t("solutions.p3")}
            </p>
          </div>
          <div className="w-full lg:w-1/2">
            <img
              src={solutionsData.image}
              alt="HVAC systems"
              className="w-full h-64 md:h-80 object-cover rounded-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
}